<template>
  <header
    class="flex items-center h-12 bg-white sm:h-14 sm:border-b sm:border-gray-200"
  >
    <div
      class="flex items-center justify-between flex-1 px-4 mx-auto md:justify-start max-w-7xl sm:px-8"
    >
      <router-link to="/">
        <img :src="logo" class="mr-2 h-10" alt="API" />
      </router-link>

      <button
        id="menu-open"
        v-if="!isMaintenanceMode"
        class="block text-gray-600 md:hidden hover:text-gray-700"
        aria-label="Toggle Mobile Menu"
        @click="$store.commit('toggleMenu')"
      >
        <i class="mdi mdi-menu"></i>
      </button>
      <div
        id="menu"
        class="fixed inset-0 z-50 items-center justify-between flex-auto bg-white md:bg-transparent md:static md:flex md:ml-12"
        :class="{ hidden: !open }"
      >
        <div
          class="flex items-center justify-between h-12 px-4 py-2 mb-6 border-b border-gray-100 md:hidden"
        >
          <span class="ml-1 text-base font-semibold text-gray-600">
            <span v-if="auth">Hi {{ name }}</span>
          </span>
          <button
            id="menu-close"
            class="block h-6 w-6 flex items-center justify-center md:hidden"
            @click="$store.commit('toggleMenu')"
          >
            <span class="sr-only">Close</span>
            <i class="mdi mdi-close md:hidden"></i>
          </button>
        </div>
        <!-- Mobile menu options -->
        <mobile @logout="logout" />
        <!-- Advisor university dropdown -->
        <universityChangeDesktop v-if="auth" />
        <!-- Desktop menu options -->
        <desktop v-if="auth" @logout="logout" />
      </div>
    </div>
  </header>
</template>

<script>
import desktopComponent from "@/components/SiteComponents/header/desktopOptions.vue";
import mobileComponent from "@/components/SiteComponents/header/mobileOptions.vue";
import universityChangeDesktop from "@/components/SiteComponents/header/universityChangeDesktop.vue";

import { Formio } from "formiojs";

export default {
  name: "header-component",
  components: {
    desktop: desktopComponent,
    mobile: mobileComponent,
    universityChangeDesktop: universityChangeDesktop
  },
  methods: {
    logout() {
      Formio.logout();
      this.$store.dispatch("resetCounts");
      this.$store.commit("logout");
      this.$router.push("/sign-in");
    }
  },
  computed: {
    isMaintenanceMode() {
      return (
        process.env.VUE_APP_MAINTENANCE_MODE &&
        process.env.VUE_APP_MAINTENANCE_MODE.toLowerCase() === "true"
      );
    },
    auth() {
      return this.$store.getters.isLoggedIn;
    },
    open() {
      return this.$store.getters.isMenuOpen;
    },
    name() {
      return this.$store.getters.getUserName;
    },
    logo() {
      return process.env.VUE_APP_CDN_ENDPOINT + "/images/api-connect-logo.png";
    }
  }
};
</script>
